import { type ComponentStateType, type DynamicPageSectionName, type SectionMap } from '~/types/template';

import styles from '../components/DynamicPageTemplate/DynamicPageTemplate.module.css';

export const getDynamicClasses = (sections: Pick<SectionMap, DynamicPageSectionName>) => {
  const getComponentNames = (section: ComponentStateType[] | null | undefined) =>
    section?.map(component => component?.name).filter(Boolean) || [];

  const sectionComponentNamesMap = {
    bottom: getComponentNames(sections.bottom),
    centerBottom: getComponentNames(sections.centerBottom),
    centerTop: getComponentNames(sections.centerTop),
    right: getComponentNames(sections.right),
    top: getComponentNames(sections.top),
  };

  const allComponentNames = Object.values(sectionComponentNamesMap).flat();

  const getClassesForSection = (sectionNames: string[]) => {
    const sectionClasses = sectionNames
      .map(componentName => {
        switch (componentName) {
          case 'GRID_GROUP':
            return styles.gridGroup;
          // Add more cases as needed
          default:
            return '';
        }
      })
      .join(' ');

    return sectionClasses;
  };

  const sectionClasses = {
    bottom: getClassesForSection(sectionComponentNamesMap.bottom),
    centerBottom: getClassesForSection(sectionComponentNamesMap.centerBottom),
    centerTop: getClassesForSection(sectionComponentNamesMap.centerTop),
    right: getClassesForSection(sectionComponentNamesMap.right),
    top: getClassesForSection(sectionComponentNamesMap.top),
    contentContainer: getClassesForSection(allComponentNames),
    mainWrapper: getClassesForSection(allComponentNames),
  };

  return sectionClasses;
};
